module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a0bac475b3ca72f294e58d84e85d0182.png";